var _style, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmazonAds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 600",
    style: {
      enableBackground: "new 0 0 800 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st2{mask:url(#mask-4_1_);fill-rule:evenodd;clip-rule:evenodd;fill:#222E3E;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#222E3E;}\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x34_kmiles-ERP_x2F_English_xFF08_banner1_xFF09_",
    transform: "translate(-1050.000000, -5983.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-53",
    transform: "translate(550.000000, 5983.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "spn"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-102",
    transform: "translate(500.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(86.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 63.8,
    y: 272.8,
    width: 187.5,
    height: 41
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 63.8,
    y: 272.8,
    width: 187.5,
    height: 41,
    id: "mask-4_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-3_1_",
    className: "st1",
    points: "63.8,272.8 251.3,272.8 251.3,313.7 63.8,313.7  "
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st2",
    d: "M249.6,289.1c-22.5,16.1-55.1,24.7-83.2,24.7c-39.4,0-74.8-14.1-101.7-37.6 c-2.1-1.8-0.2-4.4,2.3-2.9c29,16.3,64.8,26.2,101.7,26.2c24.9,0,52.4-5,77.6-15.4C250.2,282.4,253.4,286.4,249.6,289.1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    className: "st3",
    d: "M268,303.1c-2.6-3.4-17.5-1.6-24.1-0.8c-2,0.2-2.3-1.5-0.5-2.8c11.8-8.4,31.2-6,33.4-3.2 c2.3,2.9-0.6,22.6-11.7,32c-1.7,1.4-3.3,0.7-2.6-1.2C265.1,320.7,270.7,306.5,268,303.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    className: "st3",
    d: "M244.4,230.4v-9.1c0-1.4,1-2.3,2.2-2.3l39.2,0c1.3,0,2.3,1,2.3,2.3l0,7.8c0,1.3-1.1,3-3,5.7 l-20.3,30.2c7.5-0.2,15.5,1,22.4,5c1.5,0.9,2,2.2,2.1,3.6v9.7c0,1.3-1.4,2.9-2.9,2.1c-12.1-6.6-28.1-7.3-41.5,0.1 c-1.4,0.8-2.8-0.8-2.8-2.1v-9.3c0-1.5,0-4,1.5-6.3l23.6-35.2l-20.5,0C245.5,232.7,244.5,231.8,244.4,230.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    className: "st3",
    d: "M102.7,289.7H91.1c-1.1-0.1-2-1-2.1-2.1l0-64.9c0-1.3,1-2.3,2.3-2.3l10.9,0 c1.1,0.1,2,1,2.1,2.2v8.5h0.2c2.8-8.2,8.2-12,15.4-12c7.3,0,11.9,3.8,15.1,12c2.8-8.2,9.3-12,16.1-12c4.9,0,10.2,2.2,13.5,7.1 c3.7,5.5,2.9,13.4,2.9,20.3l0,40.9c0,1.3-1,2.3-2.2,2.3h-11.7c-1.2-0.1-2.1-1.1-2.1-2.3l0-34.4c0-2.7,0.2-9.6-0.3-12.2 c-0.9-4.4-3.5-5.6-6.9-5.6c-2.8,0-5.8,2-7,5.3c-1.2,3.3-1.1,8.7-1.1,12.4v34.4c0,1.3-1,2.3-2.2,2.3h-11.7 c-1.2-0.1-2.1-1.1-2.1-2.3l0-34.4c0-7.2,1.1-17.9-7.2-17.9c-8.4,0-8.1,10.4-8.1,17.9l0,34.4C105,288.7,104,289.7,102.7,289.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    className: "st3",
    d: "M324.6,232c-8.9,0-9.5,12.5-9.5,20.2c0,7.8-0.1,24.4,9.4,24.4c9.4,0,9.8-13.4,9.8-21.6 c0-5.4-0.2-11.8-1.8-16.9C331.2,233.7,328.4,232,324.6,232 M324.5,219c18,0,27.7,15.8,27.7,35.9c0,19.4-10.8,34.8-27.7,34.8 c-17.7,0-27.3-15.8-27.3-35.5C297.2,234.4,306.9,219,324.5,219"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-11",
    className: "st3",
    d: "M377.5,289.7h-11.4c-1.2-0.1-2.1-1.1-2.1-2.3l0-64.9c0.1-1.2,1-2.1,2.2-2.1l10.6,0 c1,0.1,1.8,0.8,2,1.8v9.9h0.2c3.2-8.9,7.7-13.1,15.6-13.1c5.1,0,10.2,2.1,13.4,7.6c3,5.2,3,13.9,3,20.2v40.8 c-0.1,1.2-1.1,2-2.2,2h-11.5c-1.1-0.1-1.9-0.9-2-2v-35.2c0-7.1,0.8-17.5-7.2-17.5c-2.8,0-5.4,2-6.6,5.2 c-1.6,4-1.8,7.9-1.8,12.3v34.9C379.7,288.7,378.7,289.7,377.5,289.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    className: "st3",
    d: "M228.1,288.7c-0.8,0.7-2,0.8-2.9,0.3c-4.1-3.4-4.8-5-7.1-8.2c-6.8,6.9-11.6,9-20.3,9 c-10.4,0-18.5-6.4-18.5-19.3c0-10,5.4-16.9,13.1-20.2c6.7-2.9,16-3.5,23.2-4.3v-1.6c0-2.9,0.2-6.4-1.5-9 c-1.5-2.3-4.4-3.2-6.9-3.2c-4.7,0-8.9,2.4-9.9,7.4c-0.2,1.1-1,2.2-2.1,2.3l-11.9-1.3c-1-0.2-2.1-1-1.8-2.6 c2.7-14.6,15.8-18.9,27.6-18.9c6,0,13.8,1.6,18.6,6.2c6,5.6,5.4,13.1,5.4,21.3v19.3c0,5.8,2.4,8.3,4.7,11.5 c0.8,1.1,1,2.5,0,3.3C235.1,282.6,230.6,286.5,228.1,288.7L228.1,288.7z M215.7,258.5c0,4.8,0.1,8.8-2.3,13.1 c-2,3.5-5.1,5.6-8.5,5.6c-4.7,0-7.5-3.6-7.5-9c0-10.5,9.4-12.5,18.3-12.5V258.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-15",
    className: "st3",
    d: "M70.9,288.7c-0.8,0.7-2,0.8-2.9,0.3c-4.1-3.4-4.8-5-7.1-8.2c-6.8,6.9-11.6,9-20.3,9 c-10.4,0-18.5-6.4-18.5-19.3c0-10,5.4-16.9,13.1-20.2c6.7-2.9,16-3.5,23.2-4.3v-1.6c0-2.9,0.2-6.4-1.5-9 c-1.5-2.3-4.4-3.2-6.9-3.2c-4.7,0-8.9,2.4-9.9,7.4c-0.2,1.1-1,2.2-2.1,2.3l-11.9-1.3c-1-0.2-2.1-1-1.8-2.6 C27,223.4,40.1,219,51.8,219c6,0,13.8,1.6,18.6,6.2c6,5.6,5.4,13.1,5.4,21.3v19.3c0,5.8,2.4,8.3,4.7,11.5c0.8,1.1,1,2.5,0,3.3 C77.9,282.6,73.4,286.5,70.9,288.7L70.9,288.7z M58.5,258.5c0,4.8,0.1,8.8-2.3,13.1c-2,3.5-5.1,5.6-8.5,5.6 c-4.7,0-7.5-3.6-7.5-9c0-10.5,9.4-12.5,18.3-12.5V258.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    className: "st3",
    d: "M509.3,237c-3.4,4.1-5,9.7-5,16.9c0,7.2,1.6,12.9,4.8,17.1c3.7,4.7,9.1,7.1,16.4,7.1 c6.8,0,12-2.3,15.8-7c3.3-4.2,5-9.7,5-16.4v-1.2c0-7-2-12.7-5.6-17c-3.8-4.4-8.7-6.5-14.7-6.5C518.6,230,513,232.3,509.3,237  M556.5,201.8V282c0,1.2-1.1,2.1-2.4,2.1h-4.9c-1.4,0-2.5-1-2.5-2.2v-7.7c-4.7,7.7-12.3,11.5-22.4,11.5 c-9.9,0-17.6-3.3-23.1-9.6c-5.1-5.8-7.6-13.3-7.6-22.4c0-8.9,2.5-16.1,7.6-21.9c5.5-6.5,12.9-9.7,22.6-9.7 c9.7,0,17.1,4.2,22.3,12.7v-33.4c0-1.2,1.1-2.2,2.5-2.2h5.2C555.3,199.3,556.5,200.4,556.5,201.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-33",
    className: "st3",
    d: "M476.1,259.1c0,4.9-2.3,9.3-6.8,13.1c-4.6,3.9-9.8,5.9-15.7,5.9c-3.9,0-7-1-9.4-2.8 c-2.4-2-3.5-4.3-3.5-7.2c0-9.2,7-13.8,21-14.1l14.4-0.2V259.1z M480.2,226.1c-4.4-4.8-10.9-7.1-19.8-7.1 c-2.7,0-5.1,0.2-7.4,0.6v0c-6.4,0.8-12.3,3.7-16.7,6.4c-0.8,0.5-1.1,1.5-0.7,2.3l1.8,3.7c0.4,0.9,1.6,1.3,2.5,0.8 c4.2-2.3,9.9-4.3,14.9-5.4c1.5-0.3,3.2-0.4,5-0.4c10.9,0,16.3,5.3,16.3,15.9v3.3l-15,0.2c-9.4,0.1-16.7,1.4-21.8,4.9 c-5.8,3.7-8.6,9.6-8.6,16.8c0,5.1,1.9,9.4,5.8,12.7c3.7,3.2,8.7,4.8,15,4.8c5.8,0,11-1.3,15.6-3.9c3.9-2.2,7.1-5,9.5-8.5v8.3 c0,1.3,1.1,2.4,2.4,2.4h4.3c1.3,0,2.4-1.1,2.4-2.4v-38.3C485.8,236,483.9,230.3,480.2,226.1L480.2,226.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-35",
    className: "st3",
    d: "M564.4,274c0-1.4,1.6-2.3,2.8-1.5c4.9,2.9,10.1,4.3,15.7,4.3c8.8,0,14.8-2.9,14.8-8.6 c0-2.4-1-4.5-2.9-6c-1.9-1.6-7.4-3.5-13.3-5.6c-7.1-2.8-11.7-5.6-13.8-8.4c-2.1-2.8-3.2-6.1-3.2-10c0-5.6,2.4-10.6,7.2-14 c4.8-3.4,10.7-5.1,17.7-5.1c5,0,9.7,1.3,14,2.9c0.7,0.3,1.2,0.9,1.2,1.7v6.5c0,1.4-1.4,2.2-2.7,1.6c-4.1-2-8.6-3.6-13.6-3.6 c-3.6,0-7.6,0.8-9.9,2.3s-3.9,4.2-3.9,6.7c0,2.5,0.8,4.5,2.5,5.9c1.6,1.4,6.8,3.2,12.4,5.4c7.1,2.6,12,5.4,14.5,8.2 c2.5,2.8,3.8,6.3,3.8,10.5c0,5.8-2.4,10.4-7.2,13.7c-4.8,3.3-11,5-18.7,5c-6.2,0-11.6-1.1-16.3-3.2c-0.7-0.3-1.1-0.9-1.1-1.7 V274z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonAds);
export default __webpack_public_path__ + "static/media/Amazon_ADS.b1bfbf2198ba9abdc37003d4bdad11f5.svg";
export { ForwardRef as ReactComponent };